import queryString from 'query-string';
import { httpfb, httpwmsapi } from 'src/services';

// Action Types
export const Types = {
  PRODUCT_VARIATIONS_LOADING: 'product/variations/loading',
  PRODUCT_VARIATIONS_LOADING_MODAL: 'product/variations/loading/modal',
  PRODUCT_SET_VARIATIONS: 'product/set/variations',
  PRODUCT_VARIATION_VENDA_MODAL: 'product/set/variation/venda/modal',
  PRODUCT_SET_VARIATION: 'product/set/variation',
  PRODUCT_SET_PAGING: 'product/set/variation/paging',
  PRODUCT_VARIATION_VENDA_MODAL_PAGING: 'product/variation/venda/modal/paging',
  PRODUCT_SET_FILTERS_CHIP: 'product/set/variation/filters/chip',
  PRODUCT_SET_FILTERS: 'product/set/variation/filters',
  PRODUCT_SET_ORDERBY: 'product/set/variation/orderby',
};

// Reducer
const initialState = {
  loading: false,
  loading_modal: false,
  product_variations: [],
  product_variation_venda_modal: [],
  product_variation: {},
  products_variations_filters_chip: [],
  products_variations_order: { column: 'owner_product_name', order: 'asc' },
  products_variations_paging: {
    offset: 0,
    limit: 25,
    total: 0,
  },
  product_variation_venda_modal_paging: {
    offset: 0,
    limit: 25,
    total: 0,
  },
  products_variations_filters: [],
};

// Action Creators
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.PRODUCT_VARIATIONS_LOADING:
      return { ...state, loading: action.payload };
    case Types.PRODUCT_VARIATIONS_LOADING_MODAL:
      return { ...state, loading_modal: action.payload };
    case Types.PRODUCT_SET_VARIATIONS:
      return { ...state, product_variations: action.payload };
    case Types.PRODUCT_SET_VARIATION:
      return { ...state, product_variation: action.payload };
    case Types.PRODUCT_VARIATION_VENDA_MODAL:
      return { ...state, product_variation_venda_modal: action.payload };
    case Types.PRODUCT_SET_PAGING:
      return { ...state, products_variations_paging: action.payload };
    case Types.PRODUCT_VARIATION_VENDA_MODAL_PAGING:
      return { ...state, product_variation_venda_modal_paging: action.payload };
    case Types.PRODUCT_SET_ORDERBY:
      return { ...state, products_variations_order: action.payload };
    case Types.PRODUCT_SET_FILTERS_CHIP:
      return { ...state, products_variations_filters_chip: action.payload };
    case Types.PRODUCT_SET_FILTERS:
      return { ...state, products_variations_filters: action.payload };
    default:
      return state;
  }
}

export const Creators = {
  productSetVariations: (product_variations) => ({
    type: Types.PRODUCT_SET_VARIATIONS,
    payload: product_variations,
  }),
  productSetVendaModal: (product_variation_venda_modal) => ({
    type: Types.PRODUCT_VARIATION_VENDA_MODAL,
    payload: product_variation_venda_modal,
  }),
  productSetVariation: (product_variations) => ({
    type: Types.PRODUCT_SET_VARIATION,
    payload: product_variations,
  }),
  productVariationLoading: (value) => ({
    type: Types.PRODUCT_VARIATIONS_LOADING,
    payload: value,
  }),
  productVariationLoadingModal: (value) => ({
    type: Types.PRODUCT_VARIATIONS_LOADING_MODAL,
    payload: value,
  }),
  productVariationPaging: (value) => ({
    type: Types.PRODUCT_SET_PAGING,
    payload: value,
  }),
  productVariationVendaModalPaging: (value) => ({
    type: Types.PRODUCT_VARIATION_VENDA_MODAL_PAGING,
    payload: value,
  }),

  productVariationSetOrderBy: (value) => ({
    type: Types.PRODUCT_SET_ORDERBY,
    payload: value,
  }),
  productsVariationsSetFiltersChip: (value) => ({
    type: Types.PRODUCT_SET_FILTERS_CHIP,
    payload: value,
  }),
  productsVariationsSetFilters: (value) => ({
    type: Types.PRODUCT_SET_FILTERS,
    payload: value,
  }),
  getProdutctVariations: (ean) => {
    return new Promise((resolve, reject) => {
      httpfb
        .get(`/product-variations/search`, { params: { ean } })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getProdutctVariationsAll: (filters = {}) => {
    const qry = queryString
      .stringify(filters, { arrayFormat: 'index' })
      .replaceAll('%5B', '[')
      .replaceAll('%5D', ']')
      .replaceAll('%20', '_')
      .replaceAll('physical%20quantity', 'physical_quantity');

    return new Promise((resolve, reject) => {
      httpfb
        .get(`/product-variations/search?${qry}`, { timeout: 1000 * 50 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getProdutctVariationsByID: (id) => {
    return new Promise((resolve, reject) => {
      httpfb
        .get(`/product-variations/${id}`)
        .then(({ data }) => resolve({ data }))
        .catch((error) => reject(error));
    });
  },
  getProductVariationsMapping: (variation_key, position_key) => {
    return new Promise((resolve, reject) => {
      httpfb
        .get(`/product-variations/${variation_key}/stock/positions/mapping`, {
          position_key,
        })
        .then(({ data }) => resolve({ data }))
        .catch((error) => reject(error));
    });
  },
  setProductVariationsMapping: (variation_key, position_key) => {
    return new Promise((resolve, reject) => {
      httpfb
        .post(`/product-variations/${variation_key}/stock/positions/mapping`, {
          position_key,
        })
        .then(({ data }) => resolve({ data }))
        .catch((error) => reject(error));
    });
  },
  setProductVariationsAllocation: ({ variation_key, position_key, quantity }) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(
          `/v1/allocation/stock/positions/product-variations/${variation_key}`,
          { position_key, quantity },
          { timeout: 1000 * 60 }
        )
        .then(({ data }) => resolve({ data }))
        .catch((error) => reject(error));
    });
  },
  getStockPosition: (position_key, ignoreInventoryBlock = false, variationId = undefined) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(
          `/v1/stock/position/key/${position_key}?ignoreInventoryBlock=${ignoreInventoryBlock}${variationId ? `&variationId=${variationId}` : ''}`
        )
        .then(({ data }) => resolve({ data }))
        .catch((error) => reject(error));
    });
  },
  getPickingStockPosition: (position_key, ignoreInventoryBlock = false, orderId = undefined) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(
          `/v1/stock/picking/position/key/${position_key}?ignoreInventoryBlock=${ignoreInventoryBlock}&orderId=${orderId}`
        )
        .then(({ data }) => resolve({ data }))
        .catch((error) => reject(error));
    });
  },
  getStockPositionsWithAllocatedProducts: (
    position_key,
    ignoreInventoryBlock = false,
    acceptAddressWithoutProduct = false,
    paging = {},
    productGtin = undefined,
    withAttributes = true,
    ignoreAllowPickingCheck = false,
    variationId = undefined
  ) => {
    const filters = {
      ignoreInventoryBlock,
      acceptAddressWithoutProduct,
      productGtin,
      withAttributes,
      ignoreAllowPickingCheck,
      variationId,
      ...paging,
    };

    const qry = queryString.stringify(filters, { arrayFormat: 'index' });

    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/stock/positions/key/${position_key}?${qry}`, { timeout: 1000 * 120 })
        .then(({ data }) => resolve({ data }))
        .catch((error) => reject(error));
    });
  },
  setStockPositonsMove: ({ id, old_position_key, new_position_key, quantity }) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(
          `/v1/movimentacao/product-variations/${id}/stock/positions/move`,
          {
            old_position_key,
            new_position_key,
            quantity,
          },
          { timeout: 1000 * 50 }
        )
        .then(({ data }) => resolve({ data }))
        .catch((error) => reject(error));
    });
  },
  getProductVariationsPositionsMapping: (variation_key, filters = {}) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' });
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/product-variations/${variation_key}/stock/positions/mapping?${qry}`, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getHistoricoAlocacao: (id, paging) => {
    const qry = queryString.stringify(paging, { arrayFormat: 'index' });
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/pesquisa-rapida/historico-alocacao/${id}?${qry}`)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getHistoricoInventario: (id, paging) => {
    const qry = queryString.stringify(paging, { arrayFormat: 'index' });
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/pesquisa-rapida/historico-inventario/${id}?${qry}`)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getHistoricoMovimentacao: (id, paging) => {
    const qry = queryString.stringify(paging, { arrayFormat: 'index' });
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/pesquisa-rapida/historico-movimentacao/${id}?${qry}`)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getHistoricoSeparacao: (id, paging) => {
    const qry = queryString.stringify(paging, { arrayFormat: 'index' });
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/pesquisa-rapida/historico-separacao/${id}?${qry}`)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getVendaDetalhes: (filters = {}, getSeparados = false) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' }).replaceAll('%5B', '[').replaceAll('%5D', ']');
    if (getSeparados) {
      return new Promise((resolve, reject) => {
        httpwmsapi
          .get(`/v1/product-variations/separados?${qry}`)
          .then(({ data }) => resolve(data))
          .catch((error) => reject(error));
      });
    }
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/product-variations/aguardando-separacao?${qry}`)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
};
